import { ActiveRiskType } from '../domain/stream/transaction/TransactionDomains';

class RiskTypeUtil {
  private static readonly PAGE_PATTERNS: string[] = ['/dashboard/'];

  public static requiresUrlTransform(path: string): boolean {
    return this.PAGE_PATTERNS.some((pattern) => path.includes(pattern));
  }

  public static getOppositeRiskType(currentRiskType: ActiveRiskType): ActiveRiskType {
    return currentRiskType === 'fraud' ? 'compliance' : 'fraud';
  }

  public static transformUrlForRiskType(url: string, newRiskType: ActiveRiskType): string {
    return url.replace(/_fraud_/g, `_${newRiskType}_`).replace(/_compliance_/g, `_${newRiskType}_`);
  }

  public static getRedirectUrl(currentRiskType: ActiveRiskType): string | null {
    const currentPath = window.location.pathname;

    if (!this.requiresUrlTransform(currentPath)) {
      return null;
    }

    const newRiskType = this.getOppositeRiskType(currentRiskType);
    const newPath = this.transformUrlForRiskType(currentPath, newRiskType);

    return window.location.origin + newPath + window.location.search + window.location.hash;
  }

  public static handleRiskTypeChange(currentRiskType: ActiveRiskType): void {
    const redirectUrl = this.getRedirectUrl(currentRiskType);

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.reload();
    }
  }
}

export default RiskTypeUtil;
